import type { ApplicationApi } from "./applicationApi";

export type ReportRow = Record<string, string | number | null>;

export function getReport(api: ApplicationApi, report: string, from: string, to: string): Promise<{ report: string; rows: ReportRow[] }> {
  return api.get(`reporting-operations?${new URLSearchParams({ report, from, to }).toString()}`);
}